export default class ApiException {
  status = Number;
  message = String;

  constructor(iError) {
    this.status = iError.status;
    this.message = iError.message;
  }
}
